import React, { useEffect, useState } from "react";
import { CustomCircleIcon, CustomLabel, CustomStep, CustomStepIconContainer, CustomStepper } from "./Stepper.styles";
import { StepLabel, StepIconProps, useMediaQuery } from "@mui/material";
import ParrotIcon from '../../../public/images/parrot.svg';

export interface CustomStepperProps {
  stepLabels?: string[],
  stepSize?: number,
  activeStepIndex?: number,
  onStepClick?: (index: number) => void;
}

interface CustomStepIconProps extends StepIconProps {
  label?: string;
}

export const Stepper = ({
  stepLabels,
  stepSize = 3,
  activeStepIndex = 1,
  onStepClick,
  ...rest
}: CustomStepperProps) => {

  const [steps, setSteps] = useState<string[]>([]);

  useEffect(() => {
    if (stepLabels) {
      setSteps(stepLabels)
      return
    }

    if (stepSize) {
      setSteps(Array.from({ length: stepSize }, (_, index) => ''))
      return
    }
  }, [stepLabels, stepSize]);

  const smallScreen = useMediaQuery('(max-width:600px)');

  const CustomStepIcon = (props: CustomStepIconProps) => {
    const { active, completed, label } = props;
    return (
      <CustomStepIconContainer ownerState={{ active }} sx={{ minWidth: '2rem' }}>
        {active && <ParrotIcon />}
        {label == '' ?
          <CustomCircleIcon className={completed ? 'is-completed' : ''}/> :
          <CustomLabel className={completed ? 'is-completed' : ''}>{label}</CustomLabel>
        }
      </CustomStepIconContainer>
    );
  }

  return (
    <CustomStepper activeStep={activeStepIndex}>
      {steps.map((label, index) => {
        return (
          <CustomStep key={index} onClick={() => { if(onStepClick) onStepClick(index) }}>
            <StepLabel sx={{paddingRight: label == "" && smallScreen ? "0" : "5px"}} StepIconComponent={(props) => <CustomStepIcon {...props} label={label} />} />
          </CustomStep>
        );
      })}
    </CustomStepper>
  );
};

export interface StepperProps extends React.ComponentProps<typeof Stepper> {
  as?: React.ElementType;
}

Stepper.displayName = "Stepper";